<script setup>
import {Content} from '@/Layouts/index.js';
import {useForm} from 'laravel-precognition-vue-inertia';
import {Head} from '@inertiajs/vue3';
import {__, debugForm} from "@/Utils/index.js";
import {route} from "ziggy-js";
import Tabs from "@/Pages/Auth/Register/Tabs.vue";
import {Checkbox, Form, Input, InputPassword} from "@/Components/Form/index.js";
import LoginHere from "@/Pages/Auth/Components/LoginHere.vue";
import {Button, TextLink} from "@/Components/Common/index.js";
import CloudflareTurnstileModal from "@/Components/Form/CloudflareTurnstileModal.vue";
import Socialite from "@/Pages/Auth/Components/Socialite.vue";
import StepTitle from "@/Pages/Auth/Register/StepTitle.vue";
import {ref} from "vue";

const props = defineProps({
    email: String,
    is_social_user: Boolean,
});

const form = useForm('post', route('register.store'), debugForm({
    email: props.email,
    password: '',
    password_confirmation: '',
    terms_and_conditions: false,
    cf_turnstile_token: '',
    is_social_user: props.is_social_user,
}, {
    email: 'test@bestreply.ai',
    password: 'Pa55word!',
    password_confirmation: 'Pa55word!',
    terms_and_conditions: true,
}));

const cloudflareTurnstile = ref(null);

defineOptions({layout: Content})
</script>

<template>
    <Head :title="__('Account setup')"/>

    <Tabs/>

    <StepTitle>
        <p>{{ __('Let\'s get you setup in 5 minutes so you can start replying to your emails.') }}</p>
        <p>{{ __('First tell us how you would like to login.') }}</p>
    </StepTitle>
    <Form
        class="mx-auto max-w-xl mt-5 md:mt-10 px-4 md:px-0"
        dusk="register-tab-account-setup-form"
        :form="form" @submit.prevent="form.submit">
        <Input
            autofocus
            duskComponentId="register-tab-account-setup-form-email-component"
            dusk="register-tab-account-setup-form-email-input"
            id="email" :label="__('Email')" :form="form" required autocomplete="username"/>

        <div class="sm:grid sm:grid-cols-2 sm:gap-x-5">
            <InputPassword
                duskComponentId="register-tab-account-setup-form-password-component"
                dusk="register-tab-account-setup-form-password-input"
                id="password" :label="__('Password')" :form="form" type="password" required
                autocomplete="new-password" v-if="!form.is_social_user"/>
            <Input
                duskComponentId="register-tab-account-setup-form-password-confirmation-component"
                dusk="register-tab-account-setup-form-password-confirmation-input"
                id="password_confirmation" :label="__('Re-type password')" :form="form" type="password"
                v-if="!form.is_social_user" required/>
        </div>

        <Checkbox
            duskComponentId="register-tab-account-setup-form-terms-and-conditions-component"
            dusk="register-tab-account-setup-form-terms-and-conditions-checkbox"
            id="terms_and_conditions"
            :label="__('I accept the')"
            :form="form"
        >
            <div class="ml-1.5">
                <TextLink
                    dusk="register-tab-account-setup-form-terms-and-conditions-link"
                    :href="route('terms-of-service')"
                    target="_blank"
                >
                    {{ __('Terms and Conditions') }}
                </TextLink>
            </div>
        </Checkbox>

        <CloudflareTurnstileModal ref="cloudflareTurnstile" :form v-model="form.cf_turnstile_token"/>

        <Button
            :disabled="!form.cf_turnstile_token && cloudflareTurnstile?.hasSiteKey"
            dusk="register-tab-account-setup-form-submit-button"
            :loading="form.processing" class="w-full justify-center">
            {{ __('Continue') }}
        </Button>

    </Form>

    <Socialite class="mt-4" dusk="register-tab-setup-form-socialite"/>

    <LoginHere/>
</template>
